"use strict";
//Swedish
const messages = {
  'ALERT-MIC': 'Missing Microphone',
  'ALERT-SPEAKER': 'Missing Speaker',
  'AUDIOCONTROLS-INPUT-HEADING': 'Ingång',
  'AUDIOCONTROLS-OUTPUT-HEADING': 'Produktion',
  'AUDIOCONTROLS-CANCEL-BTN-LABEL': 'Annullera',
  'AUDIOCONTROLS-SAVE-BTN-LABEL': 'Spara',
  'BACK-BTN-LABEL': 'Tillbaka',
  'CALLCONTROLS-MUTE-BTN-LABEL' : 'Stum',
  'CALLCONTROLS-HOLD-BTN-LABEL' : 'Håll',
  'CALLCONTROLS-AUDIO-BTN-LABEL' : 'Audio',
  'CALLCONTROLS-KEYPAD-BTN-LABEL' : 'Knappsats',
  'CALLCONTROLS-TRANSFER-BTN-LABEL' : 'Överföring',
  'CALLCONTROLS-NEWCALL-BTN-LABEL' : 'Nytt samtal',
  'CALLCONTROLS-HANGUP-BTN-LABEL' : 'Lägg på',
  'CALLLIST-NOCALL' : 'Inga aktiva samtal',
  'CANCEL-BTN-LABEL' : 'Annullera',
  'EMAIL-PLACEHOLDER' : 'E-postadress',
  'INCOMINGCALL-HEADER' : 'Inkommande samtal',
  'INCOMINGCALL-ACCEPT' : 'Acceptera',
  'INCOMINGCALL-DECLINE' : 'Tacka nej',
  'INCOMINGCALL-VOICEMAIL' : 'Skicka till Voicemail',
  'LOGIN-INPUT-EMAIL-PLACEHOLDER' :' Skriv in epostadress',
  'LOGIN-INPUT-PASSWORD-PLACEHOLDER' : 'Skriv in lösenord',
  'LOGIN-CHECKBOX-LABEL' : 'Kom ihåg mig',
  'LOGIN-FORGOTPASSWORD-LINK' : 'Glömt ditt lösenord?',
  'LOGIN-SIGNIN-BTN-LABEL' : 'Logga in',
  'LOGIN-FORGOTPW-INFO-TEXT' : 'Ange din e-postadress för att återställa ditt lösenord.',
  'LOGIN-INPUT-PASSWORD-ERROR' : 'Ange fullständig lösenord',
  'LOGIN-INPUT-EMAIL-ERROR' : 'Ange giltig e-',
  'LOGIN-RESETPW-INPUT-PASSWORD-ERROR': 'Lösenorden måste matcha',
  'LOGIN-FORGOTPW-RESETPASSWORD-BTN-LABEL' : 'återställa',
  'LOGIN-RESETPW-INFO-TEXT' : ', Ändra ditt lösenord. Lösenordet ska innehålla minst en bokstav, utan blank, inte börja med @, och 8 eller fler tecken.',
  'LOGIN-RESETPW-INPUT-PASSWORD-PLACEHOLDER' : 'Nytt lösenord',
  'LOGIN-RESETPW-INPUT-REPEATPASSWORD-PLACEHOLDER' : 'repetera lösenord',
  'LOGIN-RESETPW-CHANGE-BTN-LABEL' : 'Byta',
  'LOGIN-RESETPW-NOTNOW-BTN-LABEL' : 'annullera',
  'SETTINGS-VIEWALERT-BTN-LABEL' : 'Se varningar',
  'SETTINGS-VERSION' : 'version ',
  'SETTINGS-HELPDOC-BTN-LABEL' : 'hjälp Dokumentation',
  'SETTINGS-CHECKBOX-LABEL' : 'Gör det möjligt',
  'SETTINGS-CHECKBOX-HEADER' : 'Alltid på topp?',
  'SETTINGS-CLOSEALERTS-BTN-LABEL' : 'Stäng varningar',
  'SETTINGS-LOGOUT-BTN-LABEL' : 'Logga ut',
  'SETTINGS-SELECT-EXTENSION-HEADER': 'Förlängning',
  'SETTINGS-SELECT-RINGTONE-HEADER': 'Ringsignal',
  'SETTINGS-SELECT-INPUTDEVICE-HEADER': 'Inmatningsapparat',
  'SETTINGS-SELECT-OUTPUTDEVICE-HEADER': 'Utmatningsanordning',
  'SETTINGS-SELECT-INTERFACETHEME-HEADER': 'Gränssnitt tema',
  'SETTINGS-SELECT-INTERFACELANGUAGE-HEADER': 'Gränssnittsspråk',
  'CALLHISTORY-BACK-BTN-LABEL' : 'Tillbaka',
  'CALLHISTORY-CLEAR-HISTORY-BTN-LABEL' : 'Radera',
  'CALLHISTORY-HEADER' : 'Historia',
  'CALLHISTORY-NO-HISTORY-MSG' : 'Ingen samtalshistoriken',
  'ALERTLOG-SETTINGS-BTN-LABEL' : 'inställningar',
  'ALERTLOG-CLEAR-ALERT-BTN-LABEL' : 'Radera',
  'ALERTLOG-HEADER' : 'varningar',
  'ALERTLOG-NO-ALERT-MSG' : 'Inga tillgängliga varningar',
  'UTILITIES-STATUS-ONHOLD' : 'On Hold',
  'UTILITIES-STATUS-MUTED' : 'dämpad',
  'UTILITIES-STATUS-ACTIVE' : 'Aktiv',
  'UTILITIES-STATUS-DIALING' : 'uppringning',
  'ALERTITEM-HEADING-LOGIN' : 'Logga in',
  'ALERTITEM-BODY-INCORRECT-CREDENTIALS-MSG' : 'Användarnamnet eller lösenordet är felaktigt.',
  'ALERTITEM-HEADING-LOST-NETWORK-CONNECTION' : 'Förlorade nätverksanslutning . Kontrollera anslutningsstatus .',
  'DIALINPUT-PLACEHOLDER-TEXT' : 'Ange ett nummer att ringa',
  'CALLDETAILS-HOLD' : 'On Hold',
  'CALLDETAILS-MUTED': 'dämpad',
  'CALLLIST-STATUS-ACTIVE': 'Aktiv',
  'CALLLIST-STATUS-DIALING': 'uppringning',
  'CALLHISTORY-STATUS-FAILED': 'misslyckades',
  'HEADING-STATUS-CONNECTED' : 'Ansluten',
  'HEADING-STATUS-OFFLINE' : 'ej direktansluten',
  'BLIND-BTN-LABEL': 'rullgardin',
  'ATTENDED-BTN-LABEL': 'deltog',
  'SOFTPHONE-DTMF-COMMANDS': "Skriv in nummer",
  'ARIA-LOGIN-SIGNIN-BTN': "Logga in knapp",
  'ARIA-LOGIN-FORGOTPASSWORD-BTN': "Glömde knappen lösenord",
  'ARIA-CANCEL-BTN': "knappen Avbryt",
  'ARIA-LOGIN-FORGOTPW-RESETPASSWORD-BTN': "Återställ lösenord knappen",
  'ARIA-LOGIN-RESETPW-NOTNOW-BTN-LABEL': "Inte nu knapp",
  'ARIA-CALLHISTORY-BACK-BTN-LABEL': 'Tillbakaknapp',
  'ARIA-CALLHISTORY-CLEAR-HISTORY-BTN-LABEL': 'Rensa historik knapp',
  'ARIA-SETTINGS-LOGOUT-BTN': "utloggningsknappen",
  'ARIA-SETTINGS-VIEWALERT-BTN': "Se varningar knapp",
  'ARIA-SETTINGS-HELPDOC-BTN': "Hjälp dokumentation knapp",
  'ARIA-RESETPW-CHANGE-BTN-LABEL': "Ändra lösenord knapp",
  'ARIA-BACKSPACE-BTN': 'backstegsknapp',
  'ARIA-DIALING-INPUT-FIELD': 'Ringa inmatningsfältet',
  'ARIA-HEADER': 'Rubrik',
  'ARIA-CLEAR-ALERTS-BUTTON': 'Tydliga varningar knappen',
  'ARIA-ALERT-LIST': 'varningslista',
  'ARIA-CHECKBOX': 'Checkbox',
  'ARIA-SAVE-BTN': 'Spara',
  'ARIA-INPUT-FIELD': 'Inmatningsfältet',
  'ARIA-INPUT': 'Ingång',
  'ARIA-KEYPAD': 'Knappsats',
  'ARIA-KEY': 'Nyckel',
  'ARIA-AUDIO-SLIDER': 'audio reglaget',
  'ARIA-AUDIO-SLIDER-CONTROL': 'Audio skjutreglage',
  'ARIA-MENU-ITEM': 'Menyalternativ',
  'ARIA-DROP-DOWN-MENU': 'Rullgardinsmenyn',
  'ARIA-BADGE-BUTTON': 'emblem',
  'ARIA-CALL-DETAIL': 'samtals~~POS=TRUNC detalj',
  'ARIA-OPEN-SETTINGS-BUTTON': 'knappen Öppna inställningar',
  'UPDATE-HEADER': 'Uppdatering tillgänglig',
  'UPDATE-MSG': 'Vill du starta om programmet nu?',
  'UPDATE-POSTPONE-BUTTON': 'Uppskjuta (1 min)',
  'UPDATE-UPDATE-BUTTON': 'Uppdatering',
  'ARIA-UPDATE-POSTPONE-BUTTON': 'skjuta knapp',
  'ARIA-UPDATE-UPDATE-BUTTON': 'Uppdatera knapp',
  'ACTIVECALL-STATUS-RINGING': 'Ringande',
  'ACTIVECALL-STATUS-ACTIVE': 'aktiva',
  'ACTIVECALL-STATUS-DIALING': 'uppringning',
  'ACTIVECALL-STATUS-FAILED': 'misslyckades',
  'LOGIN-INPUT-SHOW': 'Show',
  'LOGIN-INPUT-HIDE': 'Dölja',
  'CALLHISTORY-TODAY': 'I dag',
  'CALLHISTORY-YESTERDAY': 'I går',
  'ALERT_FORGOT_PASSWORD': 'Glömt ditt lösenord',
  'ALERT_SETTINGS_WILL_APPLY': 'Aktiv samtal; inställningar kommer att gälla vid inaktivitet.',
  'ALERT_DIALING_OPTIONS': 'uppringnings~~POS=TRUNC',
  'ALERT_DIALING_OPTIONS_BODY': 'Saknas nummerplanen alternativ',
  'ALERT_LOGIN': 'Logga in',
  'ALERT_SOFTPHONE_EXTENSION': 'Ingen datortelefon förlängning',
  'ALERT_MORE_INFORMATION': 'För mer information besök:',
  'ALERT_LOST_CONNECTION': 'Förlorade nätverksanslutning . Kontrollera anslutningsstatus .',
  'ARIA-PLAY-BTN': 'play-knappen',
  'ARIA-STOP-BTN': 'sluta-knappen',
  'CONTACTS-STATUS-ONLINE': 'Uppkopplad',
  'CONTACTS-STATUS-OFFLINE': 'Off-line',
  'CONTACTS-STATUS-BUSY': 'Upptagen',
  'CONTACTS-STATUS-UNKNOWN': 'Okänd',
  'LABELLEDINPUT-LABEL-EMAIL': "E-postadress",
  'LABELLEDINPUT-LABEL-PASSWORD': "Lösenord",
  'LABELLEDINPUT-LABEL-TEXT': "Text",
  'LABELLEDINPUT-HINT-EMAIL': "Ange en giltig e-postadress nedan.",
  'LABELLEDINPUT-HINT-PASSWORD': "Ange ett giltigt lösenord nedan.",
  'LABELLEDINPUT-HINT-TEXT': "Ange text nedan.",
  'ARIA-ICON-AREA': 'ikon Area',
  'SETTINGS-ADVANCED-LOGGING': "Advanced Logging",
  'APPMENU-SETTINGS-BTN-LABEL': "Öppna Inställningar",
  'APPMENU-HELP-BTN-LABEL': "Hjälpdokumentation",
  'APPMENU-LOGOUT-BTN-LABEL': "Logga ut",
  'APPMENU-VERSION': "version ",
  'HEADER-SETTINGS-TITLE': "Inställningar",
  'SETTINGS-NOTIFICATIONS-BTN-LABEL': "Anmälningar",
  'SETTINGS-APPEARANCE-BTN-LABEL': "Utseende",
  'SETTINGS-CONTACTS-BTN-LABEL': "Kontakter",
  'SETTINGS-TROUBLESHOOTING-BTN-LABEL': "Felsökning",
  'SETTINGS-NOTIFICATIONS-BTN-DESCRIPTION': "Justera hur du får uppdateringar.",
  'SETTINGS-APPEARANCE-BTN-DESCRIPTION': "Ändra utseende och känsla av applikationen.",
  'SETTINGS-CONTACTS-BTN-DESCRIPTION': "Importera dina kontakter.",
  'SETTINGS-TROUBLESHOOTING-BTN-DESCRIPTION': "Verktyg som hjälper dig att ta reda på vad som är fel",
  'ARIA-BACK-BTN-LABEL': "Tillbaka",
  'HEADER-BACK-ARIA-LABEL' : 'tillbaka',
  'ENTITYLIST-SEARCH-FOUND': "hittades.",
  'ENTITYLIST-SEARCH-ITEM-PLURAL': "objekt",
  'ARIA-EVENT-LIST-ADD-NEW-GROUP': 'Ny grupp',
  'ENTITYLIST-NO-CONTACTS-FOUND': 'Inga kontakter hittades',
  'ENTITYLIST-TRY-IMPORTING': 'Prova att importera eller lägga till en kontakt.',
  'ZEROSTATE-IMPORT-BTN-LABEL': 'Importera',
  'ENTITYLIST-NO-CONTACTS-DESCRIPTION': 'Ange numret för att skicka eller importera din kontaktlista i inställningarna.',
  'ENTITYLIST-SEARCHBAR-SEARCH-CONTACTS': "Sök kontakter",
  'CONTACT-DETAILS-CARD-ZERO-STATE-BUTTON-LABEL' : 'Lägg till ett nummer',
  'CONTACT-DETAILS-CARD-ZERO-STATE-TITLE': 'Ingen kontaktinformation',
  'CONTACT-DETAILS-CARD-ZERO-STATE-DESCRIPTION': 'Lägg till ett nummer för att komma igång',
  'ARIA-CARD-DETAILS-EDIT': 'Redigera',
  'ARIA-CARD-DETAILS-DELETE': 'Radera',
  'SETTINGS-DEVICES-BTN-LABEL': "enheter",
  'SETTINGS-DEVICES-BTN-DESCRIPTION': "Ändra hur dina enheter är konfigurerade.",
  'HEADER-CONTACTS-ARIA-LABEL' : "kontakter",
  "SETTINGS-CATEGORY-HEADER-TROUBLESHOOTING": "Felsökning",
  "SETTINGS-TROUBLESHOOTING-CHECKBOX-LABEL": "Aktivera avancerad loggning",
  "SETTINGS-TROUBLESHOOTING-DESCRIPTION" : "När det är aktiverat skapar programmet avancerade loggar som hjälper till att diagnostisera programfel.",
  "SETTINGS-ADVANCED-LOGGING-TITLE" : 'Avancerad Loggning',
  'SETTINGS-CATEGORY-HEADER-ALERTS': "Varningar",
  "SETTINGS-VIEW-ALERTS-TITLE" : "Visa varningar",
  "SETTINGS-VIEW-ALERTS-DESCRIPTION": "Öppna en registrering av varningar och loggar.",
  "SETTINGS-NOTIFICATIONS-TITLE": "Ringsignal",
  "SETTINGS-NOTIFICATIONS-DESCRIPTION": "Ändra ringsignalen för inkommande röstsamtal.",
  'APPMENU-DEFAULT-THEME-BTN-LABEL': "standard",
  'APPMENU-LIGHT-THEME-BTN-LABEL': "Ljus",
  'APPMENU-DARK-THEME-BTN-LABEL': "Mörk",
  'SETTINGS-APPEARANCE-TITLE-ALWAYS-ON-TOP': "Alltid på topp",
  'SETTINGS-ALWAYS-ON-TOP-DESCRIPTION': "När aktiverat visas applikationen över dina andra applikationer.",
  'SETTINGS-APPEARANCE-CHECKBOX-LABEL': "Alltid på topp?",
  'SETTINGS-APPEARANCE-TITLE-THEME': "Tema",
  'SETTINGS-THEMES-DESCRIPTION': "Teman ändrar ansökans övergripande utseende.",
  'SETTINGS-APPEARANCE-TITLE-LANGUAGE': "Språk",
  'SETTINGS-LANGUAGE-DESCRIPTION': "Om du ändrar språket ändras det genom hela applikationen.",
  'SETTINGS-CATEGORY-HEADER-DEVICE': "anordning",
  "SETTINGS-CATEGORY-HEADER-NOTIFICATIONS" : "Anmälningar",
  "SETTINGS-CATEGORY-HEADER-APPEARANCE" : "Utseende",
  "SETTINGS-CATEGORY-HEADER-CONTACTS" : "Kontakter",
  'SETTINGS-INPUT-DEVICE-TITLE': "Inmatningsapparat",
  'SETTINGS-INPUT-DEVICE-DESCRIPTION': "Ställ in ljudenheten du vill använda för inmatning.",
  'SETTINGS-OUTPUT-DEVICE-TITLE': "Utmatningsanordning",
  'SETTINGS-OUTPUT-DEVICE-DESCRIPTION': "Ställ in ljudenheten du vill använda för utmatning.",
  'SETTINGS-CONTACTS-IMPORT-YOUR-CONTACTS': "Importera dina kontakter",
  'SETTINGS-CONTACTS-IMPORT-CONTACTS-DESCRIPTION': "Välj ditt alternativ nedan för att importera kontakter.",
  'SETTINGS-CONTACTS-SAMPLE-CSV': "Prov CSV",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-DESCRIPTION': "Genom att trycka på knappen nedan hämtar du ett CSV-fil.",
  'SETTINGS-CONTACTS-BACKUP': 'Säkerhetskopiering',
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-BUTTON': 'Hämta prov',
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-DESCRIPTION': "Genom att trycka på knappen nedan hämtar du en CSV-säkerhetskopia av dina kontakter. Detta rekommenderas före importen.",
  'SETTINGS-IMPORT-LAST-SYNC-LABEL': "Importeras",
  'SETTINGS-IMPORT-CONTACTS-SOURCES-BUTTON': "Importera",
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-BUTTON': 'Ladda ner säkerhetskopiering',
  'ZEROSTATE-ADD-CONTACT-BTN-LABEL': 'Добавить контакт',
  'CONTACT-DETAILS-CARD-MODAL-CANCEL-BUTTON': "Annullera",
  'CONTACT-DETAILS-CARD-MODAL-DELETE-BUTTON': "Radera",
  'CONTACT-DETAILS-CARD-MODAL-HEADER-DELETE-CONTACT' : "Är du säker på att du vill radera den här kontakten?",
  'CONTACT-DETAILS-CARD-MODAL-DESCRIPTION-DELETE-CONTACT': "Om du slutför den här åtgärden tas den aktuella kontaktens uppgifter permanent bort. ",
  'CONTACT-DETAILS-FORM-ERROR': 'Ett fält i formuläret nedan har ett fel.',
  'CONTACT-DETAILS-FORM-PERSONAL-INFO-HEADER': 'Personlig information',
  'CONTACT-DETAILS-FORM-FIRST-NAME-HEADER': 'Förnamn',
  'CONTACT-DETAILS-FORM-FIRST-NAME-PLACEHOLDER': 'Ange förnamn',
  'CONTACT-DETAILS-FORM-LAST-NAME-HEADER': 'Efternamn',
  'CONTACT-DETAILS-FORM-LAST-NAME-PLACEHOLDER': 'Ange efternamn',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-HEADER': 'Företag',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-PLACEHOLDER': 'Ange företagsnamn',
  'CONTACT-DETAILS-FORM-PHONE-NUMBERS-HEADER': 'Telefonnummer',
  'CONTACT-DETAILS-FORM-PHONE-BTN-LABEL': 'Lägg till telefon',
  'CONTACT-DETAILS-FORM-CANCEL-BTN-LABEL': 'Annullera',
  'CONTACT-DETAILS-FORM-SAVE-BTN-LABEL': 'Spara',
  'CONTACT-DETAILS-FORM-NEW-CONTACT-HEADER': 'Ny kontakt',
  'CONTACT-DETAILS-FORM-EDIT-CONTACT-HEADER': 'Redigera kontakt',
  'CONTACT-DETAILS-FORM-INPUT-ERROR': 'Det här fältet kan inte lämnas tomt.',
  'CONTACT-DETAILS-FORM-NUMBER-HEADER':'Nummer',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR':'Ange ett giltigt 10-siffrigt nummer',
  'CONTACT-DETAILS-FORM-NUMBER-PLACEHOLDER':'Skriv in nummer...',
  'CONTACT-DETAILS-FORM-PREFERRED-LABEL':'Föredragen?',
  'CONTACT-DETAILS-FORM-SELECT-HOME': 'Hem',
  'CONTACT-DETAILS-FORM-SELECT-BUSINESS': 'Företag',
  'CONTACT-DETAILS-FORM-SELECT-MOBILE': 'Mobil',
  'CONTACT-DETAILS-FORM-SELECT-OTHER': 'Andra',
  'CONTACT-DETAILS-FORM-SELECT-LABEL': 'Märka',
  'NUMBER-SELECTION-MODAL-SELECT-NUMBER-TO-CALL': 'Välj det nummer som ska ringas',
  'NUMBER-SELECTION-MODAL-PREFERRED': 'Föredragen',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR-PROP':'Ange ett giltigt nummer'

};
module.exports = messages;



// WEBPACK FOOTER //
// ./src/locales/locale-sv.js